export const listOrganizations = `
   query listOrganizations($filter: OrganizationsFilterInput, $limit: Int, $nextToken:  String) {
       listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              name
              adminAccountId
              description
              email
              url
              phone
              createdByUsername
              created
              updated
           }
       }
   }
`;

export const getOrganization = `
   query getOrganization($id:ID!) {
       getOrganization(id:$id) {
         id
         name
         adminAccountId
         description
         email
         url
         phone
         createdByUsername
         created
         updated
       } 
}`;
